import { Organizations } from '../../../types';

export default class PartnerCompanyState {
  service_centers: Organizations.ServiceCenter[] = [];
}
